export default __webpack_public_path__ + "static/media/015-measuring spoon.e0c2e7a5.svg";